import React from 'react';
import { FiCheckCircle, FiXCircle, FiClock, FiRefreshCw, FiAlertCircle } from 'react-icons/fi';

const BrokerStatusBadge = ({ integration }) => {
  const getStatusConfig = () => {
    // Issue #44: explicit needs_reauth takes precedence over the expiry heuristic
    // below. The backend has already decided the integration is unusable; surface
    // a clearer "Reconnect Required" CTA instead of a generic "Token Expired".
    if (integration.status === 'needs_reauth') {
      return {
        status: 'needs_reauth',
        color: 'orange',
        icon: FiRefreshCw,
        text: 'Reconnect Required',
        bgColor: 'bg-orange-500/10',
        textColor: 'text-orange-500',
        borderColor: 'border-orange-500/20'
      };
    }

    // Check if expired based on expiresAt or sessionExpiration
    const now = new Date();
    const expiresAt = integration.credentials?.expiresAt ? new Date(integration.credentials.expiresAt) : null;
    const sessionExpiration = integration.credentials?.sessionExpiration ? new Date(integration.credentials.sessionExpiration) : null;
    const expirationDate = expiresAt || sessionExpiration;

    if (expirationDate && expirationDate < now) {
      return {
        status: 'expired',
        color: 'orange',
        icon: FiRefreshCw,
        text: 'Token Expired',
        bgColor: 'bg-orange-500/10',
        textColor: 'text-orange-500',
        borderColor: 'border-orange-500/20'
      };
    }

    switch (integration.status) {
      case 'active':
        return {
          status: 'active',
          color: 'green',
          icon: FiCheckCircle,
          text: 'Connected',
          bgColor: 'bg-green-500/10',
          textColor: 'text-green-500',
          borderColor: 'border-green-500/20'
        };
      case 'pending':
        return {
          status: 'active',
          color: 'green',
          icon: FiCheckCircle,
          text: 'Active',
          bgColor: 'bg-green-500/10',
          textColor: 'text-green-500',
          borderColor: 'border-green-500/20'
        };
      case 'error':
        return {
          status: 'error',
          color: 'red',
          icon: FiXCircle,
          text: 'Error',
          bgColor: 'bg-red-500/10',
          textColor: 'text-red-500',
          borderColor: 'border-red-500/20'
        };
      default:
        return {
          status: 'unknown',
          color: 'gray',
          icon: FiAlertCircle,
          text: 'Unknown',
          bgColor: 'bg-gray-500/10',
          textColor: 'text-gray-500',
          borderColor: 'border-gray-500/20'
        };
    }
  };

  const config = getStatusConfig();
  const Icon = config.icon;

  return (
    <div className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full ${config.bgColor} ${config.textColor} border ${config.borderColor}`}>
      <Icon className="w-4 h-4" />
      <span className="text-sm font-medium">{config.text}</span>
      {integration.metadata?.isVerified && config.status === 'active' && (
        <span className="text-xs opacity-75">• Verified</span>
      )}
    </div>
  );
};

export default BrokerStatusBadge;